import { useEffect } from 'react';

export default function About() {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'schema-about';
    script.text = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      '@id': `${import.meta.env.VITE_SITE_URL ?? ''}/about#webpage`,
      url: `${import.meta.env.VITE_SITE_URL ?? ''}/about`,
      name: 'About - 글로벌 이름 테스트 서비스 소개',
      description: '글로벌 이름 테스트와 이름 궁합률 테스트 서비스를 소개합니다. 재미로 즐기는 이름 변환 및 궁합 분석 서비스예요.',
      inLanguage: 'ko',
      isPartOf: {
        '@id': `${import.meta.env.VITE_SITE_URL ?? ''}/#website`,
      },
      breadcrumb: {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '홈', item: import.meta.env.VITE_SITE_URL ?? '' },
          { '@type': 'ListItem', position: 2, name: 'About', item: `${import.meta.env.VITE_SITE_URL ?? ''}/about` },
        ],
      },
    });
    document.head.appendChild(script);
    return () => {
      document.getElementById('schema-about')?.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 via-purple-50 to-blue-50">
      <div className="max-w-2xl mx-auto px-4 py-16">
        <a href="/" className="inline-flex items-center gap-2 text-purple-500 hover:text-purple-700 mb-10 cursor-pointer transition-colors">
          <i className="ri-arrow-left-line w-5 h-5 flex items-center justify-center"></i>
          <span className="text-sm font-medium">홈으로 돌아가기</span>
        </a>

        <div className="bg-white rounded-3xl shadow-xl p-10">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">About</h1>
          <div className="w-12 h-1 bg-gradient-to-r from-pink-500 to-purple-500 rounded-full mb-8"></div>

          <div className="space-y-8 text-gray-600 leading-relaxed">
            <p className="text-lg">
              이 사이트는 <strong className="text-gray-800">이름을 주제로 한 재미있는 테스트 서비스</strong>입니다.<br />
              두 가지 기능을 통해 이름을 다양한 방식으로 즐길 수 있습니다.
            </p>

            {/* 글로벌 이름 */}
            <div className="bg-purple-50 rounded-2xl p-6">
              <div className="flex items-center gap-2 mb-3">
                <span className="text-2xl">🌍</span>
                <h2 className="text-base font-bold text-purple-700">글로벌 이름 테스트</h2>
              </div>
              <p className="text-sm text-gray-600 leading-relaxed mb-3">
                한국 이름을 입력하면 세계 여러 나라에서 어떻게 불릴지 소리 기반으로 변환해 보여줍니다.
                일본, 중국, 미국, 스페인, 프랑스, 독일, 아랍, 브라질, 러시아, 태국 등 다양한 나라의 이름 스타일로 재미있게 변환됩니다.
              </p>
              <p className="text-xs text-purple-600 font-medium">
                🗺 지원 국가: 일본 · 중국 · 미국 · 스페인 · 프랑스 · 독일 · 아랍 · 브라질 · 러시아 · 태국
              </p>
            </div>

            {/* 이름 궁합 */}
            <div className="bg-pink-50 rounded-2xl p-6">
              <div className="flex items-center gap-2 mb-3">
                <span className="text-2xl">💕</span>
                <h2 className="text-base font-bold text-pink-700">이름 궁합률 테스트</h2>
              </div>
              <p className="text-sm text-gray-600 leading-relaxed">
                두 이름을 입력하면 궁합 점수와 등급을 확인할 수 있습니다.<br />
                대화 궁합, 감정 궁합, 취향 궁합, 미래 궁합 등 네 가지 항목을 기반으로 재미있는 분석 결과를 제공합니다.
                연인, 친구, 가족 등 누구와도 가볍게 즐길 수 있는 콘텐츠입니다.
              </p>
            </div>

            <div className="bg-gray-50 rounded-2xl p-6">
              <div className="flex items-center gap-2 mb-3">
                <span className="text-2xl">📌</span>
                <h2 className="text-base font-bold text-gray-700">안내</h2>
              </div>
              <p className="text-sm text-gray-500 leading-relaxed">
                이 서비스는 정확한 번역이나 언어학적 분석을 제공하는 것이 아니라,
                순수하게 <strong className="text-gray-700">재미와 흥미</strong>를 위해 만들어진 테스트 서비스입니다.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
